
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/my-profile/reset-password",
      function () {
        return require("private-next-pages/my-profile/reset-password.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/my-profile/reset-password"])
      });
    }
  